import { ReactNode } from 'react'
import { Typography, styled } from '@mui/material'
import { BottomDrawer } from '$common/bottom-drawer'
import { nothing } from '$helper/functions/utils'
import { useIsDesktopSize } from '$common/react-hooks/layout'

interface Props {
  isOpen: boolean
  icon: ReactNode
  title: ReactNode | string
  description: ReactNode | string
  actionButtons: ReactNode
  hideBackdrop?: boolean
}

export const ErrorPage = ({
  isOpen,
  icon,
  title,
  description,
  actionButtons,
  hideBackdrop,
}: Props) => {
  const isDesktop = useIsDesktopSize()
  return (
    <StyledBottomDrawer
      hideBackdrop={hideBackdrop}
      onClose={nothing}
      isOpen={isOpen}
      isFullscreen
    >
      {/* Do not remove data-is-desktop prop hence it is used in StyledBottomDrawer styles */}
      <Container data-is-desktop={isDesktop} className="error-page__container">
        <EmptyDiv />
        <Content>
          {icon}
          {typeof title === 'string' ? (
            <Typography
              mb="16px"
              mt="32px"
              textAlign="center"
              variant="h2"
              color="neutral1000"
            >
              {title}
            </Typography>
          ) : (
            title
          )}

          {typeof description === 'string' ? (
            <Typography
              textAlign="center"
              variant="paragraph1"
              color="neutral900"
            >
              {description}
            </Typography>
          ) : (
            description
          )}
        </Content>
        <ButtonsContainer>{actionButtons}</ButtonsContainer>
      </Container>
    </StyledBottomDrawer>
  )
}

const StyledBottomDrawer = styled(BottomDrawer)`
  z-index: ${({ theme }) => theme.zIndex.tooltip + 1};
  .error-page__container {
    width: 400px;
    max-width: 100%;
    &[data-is-desktop='true'] {
      height: 480px;
      max-height: 100%;
    }
  }
`

const Container = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  max-width: 400px;
  margin: auto;
`

const EmptyDiv = styled('div')`
  width: 0;
  height: 0;
`

const Content = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`
